import { createContext } from 'react'

import type { Customisations } from '@lorikeetai/web-sdk/types'

export const CustomisationContext = createContext<Customisations | undefined>(
  undefined,
)
// exposed for storybook
export const InvertAlignmentContext = createContext<boolean | undefined>(false)
